<div class="container">
  <ul class="nav nav-secondary">
    <a
      class="nav-item btn"
      [routerLink]="['/rewards']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.marketplace.screenreader' | translate : { fgbdefault: 'Move to Marketplace page' } }}"
    >
      <label class="mb-0">{{ 'rewards.nav.marketplace' | translate }}</label>
    </a>
    <a
      class="nav-item btn"
      [routerLink]="['/rewards/events']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.events.screenreader' | translate }}"
    >
      <label class="mb-0">{{ 'rewards.nav.events' | translate }}</label>
    </a>
    <a
      class="nav-item btn"
      [routerLink]="['/rewards/raffles']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.raffles.screenreader' | translate : { fgbdefault: 'Move to Raffles page' } }}"
    >
      <label class="mb-0">{{ 'rewards.nav.lotto' | translate }}</label>
    </a>
    <a
      class="nav-item btn d-none d-lg-block"
      [routerLink]="['/rewards/wallet']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.wallet.screenreader' | translate : { fgbdefault: 'Move to Wallet page' } }}"
    >
      <label class="mb-0">{{ 'rewards.nav.wallet' | translate }}</label>
    </a>
  </ul>
</div>
